export default "__VITE_ASSET__63aefbb7__"